import { useState, useContext } from "react"
import { CustomButton } from "../components/global/CustomButton"
import { Link, useNavigate } from "react-router-dom"
import { CustomGoogleButton } from "../components/global/CustomGoogleButton"
import { UserContext } from "../contexts/UserContext"
import "../styles/signin.css"

export function Login() {
    const [emailOrPhone, setEmailOrPhone] = useState("admin@example.com")
    const [password, setPassword] = useState("johndoe")

    const navigate = useNavigate()

    const userDataContext = useContext(UserContext)
    const { dispatch } = userDataContext
    //${process.env.REACT_APP_API_BASE_URL}
    async function handleLogin() {
        //const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/login`, {
        const response = await fetch(`http://localhost:3001/api/login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ emailOrPhone, password })
        })
        const json = await response.json()
    
        if(response.ok) {
            const { user, token } = json
            localStorage.setItem("user", JSON.stringify({ user, token }))
            dispatch({ type: "LOGIN", payload: { user, token } })
            navigate("/")
        } else {
            console.log(json)
        }
    }

    return (
        <div className="signin main login d-flex align-items-center justify-content-between">

            <img src="/images/login-image.jpg" alt="" />

            <div className="signin-form">
                <div className="form-title mb-2">Log in to Exclusive</div>
                <p className="text-black">Enter your details below</p>

                <div className="d-flex flex-column mb-4">
                    <input
                        type="text"
                        placeholder="Email or Phone number"
                        value={emailOrPhone}
                        onChange={(e) => setEmailOrPhone(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>

                <div className="d-flex align-items-center mb-2 btns">

                    <div>
                        <CustomButton
                            color="primary"
                            text="Log In"
                            btnFunction={handleLogin}
                        />
                    </div>

                    <div className="text-center">
                       <Link className="primary-text text-center">Forget Password?</Link>
                    </div>

                </div>

                <CustomGoogleButton text="Log in" />

                <div className="mt-5 text-center new-text">
                    Don't have an account? <Link to="/signup">Sign up</Link>
                </div>

            </div>

        </div>
    )
}